// TODO: (vivian) now handle by kc, remove after release

import React, { useState, InputHTMLAttributes, useEffect } from 'react';
import { RxEyeOpen, RxEyeNone } from 'react-icons/rx';

import styles from './PasswordInput.module.css';
import publicStyles from '../../pages/PublicPage.module.css';

interface PasswordInputProps extends InputHTMLAttributes<HTMLInputElement> {
  showRequirements?: boolean;
  setIsPasswordRequirementMet?: (isMet: boolean) => void;
}

export default function PasswordInput({
  showRequirements = false,
  setIsPasswordRequirementMet,
  ...props
}: PasswordInputProps) {
  const [password, setPassword] = useState('');
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const passwordRequirements = {
    minLength: password.length >= 8,
    hasUppercase: /[A-Z]/.test(password),
    hasLowercase: /[a-z]/.test(password),
  };

  useEffect(() => {
    const allRequirementsMet =
      passwordRequirements.minLength &&
      passwordRequirements.hasUppercase &&
      passwordRequirements.hasLowercase;

    if (setIsPasswordRequirementMet) {
      setIsPasswordRequirementMet(allRequirementsMet);
    }
  }, [
    password,
    setIsPasswordRequirementMet,
    passwordRequirements.minLength,
    passwordRequirements.hasUppercase,
    passwordRequirements.hasLowercase,
  ]);

  return (
    <>
      <div className={styles['password-container']}>
        <input
          {...props}
          className={publicStyles['input-field']}
          type={isPasswordVisible ? 'text' : 'password'}
          value={password}
          onChange={handlePasswordChange}
        />
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className={styles['password-toggle']}
        >
          {isPasswordVisible ? (
            <RxEyeNone size={20} />
          ) : (
            <RxEyeOpen size={20} />
          )}
        </button>
      </div>
      {showRequirements && (
        <div className={styles['password-requirement']}>
          <ul>
            <li
              className={
                passwordRequirements.minLength ? styles['requirement-met'] : ''
              }
            >
              At least 8 characters
            </li>
            <li
              className={
                passwordRequirements.hasUppercase
                  ? styles['requirement-met']
                  : ''
              }
            >
              At least one uppercase letter
            </li>
            <li
              className={
                passwordRequirements.hasLowercase
                  ? styles['requirement-met']
                  : ''
              }
            >
              At least one lowercase letter
            </li>
          </ul>
        </div>
      )}
    </>
  );
}
